import LinkButton from 'components/shared/button/LinkButton';
import GNESingleSelect from 'components/shared/dropdown/GNESingleSelect';
import GNEModal from 'components/shared/modal/Modal';
import {
  ACTION_ADD_TO_VIEW,
  CONFIGURE_VIEW,
  COPY_VIEW_SUCCESS_MESSAGE,
} from 'constants/constants';
import { useEffect, useState } from 'react';
import { Button } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { addInsightCard } from 'store/customer/customer-view-actions';
import { addToMyView } from 'store/home/home-my-view-actions';
import { createCardPayload, formatViewOwnerOptionLabel } from 'utils/utils';

function CopyTileToViewModal({
  copyTileToViewModal,
  handlePopup,
  page,
  currentView,
  card,
}) {
  const [dropDownOptions, setDropDownOptions] = useState([]);
  const { allMViews } = useSelector((state) => state?.HomeMyView);
  const allInsightViews = useSelector(
    (state) => state?.CustomerView?.allInsightViews
  );

  const isInsights = page === CONFIGURE_VIEW.insights;

  useEffect(() => {
    isInsights
      ? setDropDownOptions(allInsightViews)
      : setDropDownOptions(allMViews);
  }, []);

  const options = dropDownOptions?.reduce((acc, item) => {
    if (item?.Id !== currentView?.Id) {
      acc?.push({
        ...item,
        value: item?.name,
        label: item?.name,
      });
    }
    return acc;
  }, []);

  const [selectedView, setSelectedView] = useState(null);

  const onSave = async () => {
    if (isInsights) {
      const cardData = createCardPayload(
        card,
        null, // Position Index will be calculated at backend
        ACTION_ADD_TO_VIEW,
        selectedView?.Id
      );
      const response = await addInsightCard(cardData);
      if (response.error?.code === 422) {
        toast.error(response.message);
      } else if (response?.cardId) {
        toast.success(COPY_VIEW_SUCCESS_MESSAGE);
        handlePopup(false);
      }
    } else {
      const payload = createCardPayload(
        card,
        null, // Position Index will be calculated at backend
        ACTION_ADD_TO_VIEW,
        selectedView?.Id
      );

      const response = await addToMyView(payload);

      if (response.error?.code === 422) {
        toast.error(response.message);
      } else if (response?.cardId) {
        toast.success(COPY_VIEW_SUCCESS_MESSAGE);
        handlePopup(false);
      }
    }
  };

  const onClose = () => {
    handlePopup(false);
  };

  const onViewSelection = (selected) => {
    setSelectedView(selected);
  };

  const content = (
    <div className={`w-100 p-2`}>
      <div className='d-flex align-items-center'>
        <i className={`icon icon__copy-insight-popup me-2`}></i>
        <span className='text text__text-medium text__bold text-black-100'>
          {' '}
          {isInsights ? 'Copy Tile to Another View' : 'Copy to My Views'}
        </span>
      </div>
      <div className='text text__small mt-2 text-black-100'>
        {isInsights
          ? 'Please select a view from this insight board to copy this tile into.'
          : 'Please select a view to copy this tile into.'}
      </div>

      <div className={`w-100 mt-4 mb-5 me-2 `}>
        <GNESingleSelect
          value={selectedView}
          placeholder='Select View'
          onChange={onViewSelection}
          options={options}
          className={`single-select`}
          formatOptionLabel={(data, { context }) =>
            formatViewOwnerOptionLabel({ ...data, page }, { context })
          }
        />
      </div>

      <div className={`d-flex justify-content-end w-100`}>
        <LinkButton
          className='text text__small'
          onClick={onClose}>
          Cancel
        </LinkButton>
        <Button
          variant='btn btn-gne btn-primary'
          onClick={onSave}
          className={`text__small ms-3`}
          disabled={!selectedView || !Object.keys(selectedView).length}>
          Save
        </Button>
      </div>
    </div>
  );

  return (
    <>
      {copyTileToViewModal && (
        <GNEModal
          show={copyTileToViewModal}
          onHide={() => {
            handlePopup(false);
          }}
          content={content}
          css={`size-medium`}
          backdrop='static'
        />
      )}
    </>
  );
}

export default CopyTileToViewModal;
